import { CourseTitle } from './CourseTitle';

export default CourseTitle;
